import { IMenuItem } from "../types";

export const menuItems: IMenuItem[] = [
  { text: "Om oss", url: "#about" },
  { text: "Varför oss?", url: "#features" },
  { text: "Projekt", url: "#projects" },
  { text: "Priser", url: "#pricing" },
];
